export const VARIANTS = [
    'primary', 'success', 'warning', 'danger', 'secondary', 'neutral', 'neutral-light',
    'outline-primary', 'outline-success', 'outline-warning', 'outline-danger', 'outline-secondary', 'outline-neutral',
];
